import { Target, Compass } from "lucide-react";
import { ScrollReveal } from "../ui/ScrollReveal";
import { MISSION_ITEMS } from "../../data/content";

export const VisionMission = () => {
  return (
    <section className="relative bg-[#0b1528] py-24 sm:py-32 px-5 sm:px-8" data-testid="vision-mission-section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16">
        <ScrollReveal>
          <div className="flex items-center gap-3 mb-6">
            <Compass size={20} className="text-cyan-400" />
            <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">Our Vision</span>
          </div>
          <h2 className="font-display font-extrabold uppercase text-2xl sm:text-3xl text-white leading-tight">
            The World's Leading Health, Fitness &amp; Holistic Wellness OTT Platform.
          </h2>
          <p className="text-slate-400 mt-5 text-sm sm:text-base leading-relaxed">
            A world where anyone, anywhere, regardless of their background, can access structured health and
            wellness guidance. One platform. One membership. A healthier world — where people don't wait until
            they become unhealthy to take care of themselves.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.15}>
          <div className="flex items-center gap-3 mb-6">
            <Target size={20} className="text-cyan-400" />
            <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">Our Mission</span>
          </div>
          <h3 className="font-display font-bold text-lg text-white mb-6">To Make Health Accessible To Everyone.</h3>
          <div className="space-y-4">
            {MISSION_ITEMS.map((m) => (
              <div key={m.title} className="border-l-2 border-cyan-500/30 pl-4" data-testid={`mission-item-${m.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <h4 className="font-semibold text-white text-sm">{m.title}</h4>
                <p className="text-xs sm:text-sm text-slate-400 mt-1">{m.desc}</p>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
